/**
 * @generated SignedSource<<833f0d43b7faa48c2e87e41a9cbc4bf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemFooterDone_todo$data = {
  readonly contact: {
    readonly __typename: "TodoContact";
  } | null;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemContact_todo">;
  readonly " $fragmentType": "TodoListItemFooterDone_todo";
};
export type TodoListItemFooterDone_todo$key = {
  readonly " $data"?: TodoListItemFooterDone_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooterDone_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemFooterDone_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemContact_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "6955fead13002408f055a6e651345a67";

export default node;
